import { useSiteContent } from '@personal-portfolio/queries';
import { Card, CardContent } from '@/shared/ui/card';
import { ResumeDownloadPopup } from './resume-download-popup';
import { cn } from '@/shared/lib/cn';

/**
 * "Get my resume" card (shared by the header sheet, sidebar and right
 * sidebar), wrapping the resume download popup trigger.
 */
export function ResumeCard({ className }: { className?: string }) {
  const { resume } = useSiteContent();
  return (
    <Card className={cn('border-border shadow-xs', className)}>
      <CardContent className="space-y-4 px-6">
        <div className="space-y-1.5">
          <h3 className="text-base leading-tight font-semibold tracking-tight text-foreground">
            {resume.cardTitle}
          </h3>
          <p className="text-sm text-muted-foreground">{resume.cardBody}</p>
        </div>
        <ResumeDownloadPopup />
      </CardContent>
    </Card>
  );
}
